<template>
  <div id="subject">
    <div class="bg-color-black">
    <div class="d-flex pt-2 pl-2">
         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">科技型企业（高企）培育</span>
        </span>
    </div>
    <div class="up">
      <div class="item" v-for="(item,pi) in subItem" :key="pi" >
        <p style="font-size: 14px;color:#5cd9e8;text-align: center">
          <i class="icon-dot" :style="{'color':color[pi]}"></i>{{item.name}}</p>
        <div class="d-flex">
          <span>{{item.value}}家</span>
        </div>
        <div class="d-flex " style="text-align: center;justify-content: center;width: 100%">
          <Schart :item="item" :range="tag" ></Schart>
        </div>
      </div>

    </div>
    </div>
  </div>
</template>

<script>
 import Schart from '@/components/newbase/subechart'
import sciApi from '@/api/index.js'
export default {
  components: {Schart},
  data () {
  return {
      tag:'',// 所选地区
      options: {},
      allNum:0,// 总数
      subItem:[],// 四个分类各有多少家
      subject:[],// 回显数据
      color:['#eacf19','#8378ea','#e7bcf3','#fb7293','#ff9f7f',],
      Num:{
        '高企':0,
        '潜在高企培育对象':0,
        '科技型企业':0,
        '潜在科技培育对象':0,
        // '高企库':0,
        // '潜在高企培育库':0,
        // '科技型企业库':0,
        // '潜在科技培育库':0,
      }
      // 通过率和达标率的组件复用数据
    };
  },
  // components: {
  //   Echart
  // },
  watch:{
    setregion:{
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val
      }
    },
    tag:{
      immediate: false,
      deep: true,
      handler(val) {
        console.log(val,'val')
        this.init().then(()=>{
          let num=[]
          for (let key in this.Num){
            num.push({ name:key,
              value:this.Num[key],allNum:this.allNum})
          }
          //
          this.subItem = num.slice(0,4)
        })
      }
    }
  },
  computed:{
    setregion() {
      // console.log(this.$store.state.region)
      return this.$store.state.region
    }
  },
  mounted() {
    this.tag=''
    this.init().then(()=>{
      let num=[]
      for (let key in this.Num){
        num.push({ name:key,
          value:this.Num[key],allNum:this.allNum})
      }
      this.subItem = num.slice(0,4)
      console.log('初始化数据', this.subItem)
      // Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
    })
  },
  methods: {
    async init(){
      const that = this;
      return await sciApi.selectSubject({pageSize: 1000,pageNum: 1}).then((data)=>{
        // data 就是接口返回值
        this.subject = data.list || []
        if(this.tag!==''){
          this.subject.forEach((item) => {
            if(item.mapAreaDisplay == that.tag)
            {
              that.Num[item.epLevel1Display] += parseInt(item.mapNum);
            }else {
              that.Num[item.epLevel1Display] = 0;
            }
          })
        }
        else {
          this.subject.forEach((item) => {
            this.allNum += parseInt(item.mapNum);
            that.Num[item.epLevel1Display] += parseInt(item.mapNum);
          })
        }
      })
    },
  },

};
</script>

<style lang="scss" scoped>
#subject {
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    //justify-content: space-around;
    .item {
      float: left;
      border-radius: 0.0625rem;
      padding-top: 0.2rem;
      margin-top: 0.1rem;
      width: 25%;
      height: 0.875rem;
    }
    .item span{
      font-size: 18px;
      color: #fff;
      line-height: 0.4rem;
      height: 0.4rem;
      text-align: center;
      width: 100%;
    }
    .label {
      width: 25%;
      //position: absolute;
      //left: 1.75rem;
      //top: 0.75rem;
      color: #4996f5;
      font-size: 0.583rem;
    }
  }
}
</style>